import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addreferralSchema = Yup.object().shape({
    // bonusamount: Yup.string()
    // .matches(/^\$\d+(\.\d{1,2})?$/, CommonMessages.bonusamount_required) // Ensures string starts with $ and is followed by a valid amount
    // .required(CommonMessages.bonusamount_required),
    // bonusamountcount: Yup.string()
    // .required(CommonMessages.bonusamount_required)
    // .notOneOf(['0'], CommonMessages.advertisementtype_required),
    // referralbonuslimit: Yup.string()
    // .required(CommonMessages.referralbonuslimit_required),
    referralsubscription: Yup.number().required("ReferralSubscription s requred"),
    freesinglewash: Yup.number().required("ReferralSubscription s requred"),

    description: Yup.string()
        .required(CommonMessages.description_required),
    // referralbenefit: Yup.boolean()
    // .required(CommonMessages.referralbenefit_required),
    // referralbenefitamount: Yup.string().when('referralbenefit', {
    //     is: (val: boolean) => val,  // Check if referralbenefit is true
    //     then: (schema) => schema
    //         .matches(/^\$\d+(\.\d{1,2})?$/, CommonMessages.referralbenefitamount_required)  // Regex for $ amount format
    //         .required(CommonMessages.referralbenefitamount_required),  // Field is required if referralbenefit is true
    //     otherwise: (schema) => schema.required(CommonMessages.referralbenefitamount_required)  // Only required check if referralbenefit is false
    // }),

})